module.exports = __webpack_public_path__ + "static/media/singles_tierlist.9f2c92d1.png";